import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/GasItems/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/GasItems/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/GasItems/GetById`, payload),
    Add: (payload) => Repository.post(`/api/GasItems/Add`, payload),
    Edit: (payload) => Repository.post(`/api/GasItems/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/GasItems/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/GasItems/ChangeStatus`, payload),
}